import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { ProductDetails_product_variants } from "@the-volte/svc-core-sdk/lib/queries/gqlTypes/ProductDetails";
import React from "react";

import { Checkbox } from "@components/atoms";
import { getProductPrice } from "@components/organisms/AddToCartSection/stockHelpers";

interface IProps {
  productVariants:
    | (ProductDetails_product_variants | null)[]
    | null
    | undefined;
  setVariantId: (variant_id: string) => void;
  variantId: string;
}

const ProductVariantSelector: React.FC<IProps> = ({
  productVariants,
  setVariantId,
  variantId,
}) => (
  <VStack width="100%" alignItems="left" mb={{ base: 6, md: 2 }}>
    {productVariants
      ?.sort((a, b) => (a?.rentalDays || 0) - (b?.rentalDays || 0))
      ?.map((pv) =>
        // @ts-expect-error
        pv?.disabled ? (
          <Flex key={pv?.id} direction="row" alignItems="center" height="30px">
            <Box width="1.5rem">
              <Checkbox
                name={pv?.name || ""}
                checked={pv?.id === variantId}
                onChange={() => setVariantId(pv?.id || "")}
                disabled
              />
            </Box>
            <Box
              textAlign="left"
              style={{
                fontSize: "1rem",
                color: "red",
              }}
            >
              {pv?.name || ""}
              {` (`}Unavailable for this date{`) `}
            </Box>
          </Flex>
        ) : (
          <Flex key={pv?.id} direction="row" alignItems="center" height="30px">
            <Checkbox
              name={pv?.name || ""}
              checked={pv?.id === variantId}
              onChange={() => setVariantId(pv?.id || "")}
            >
              <Text mr={2} whiteSpace="nowrap">
                {pv?.name || ""}
              </Text>

              {pv?.id !== variantId && (
                <span>
                  {` (`}
                  {getProductPrice(null, pv?.pricing)})
                </span>
              )}
            </Checkbox>
          </Flex>
        )
      )}
  </VStack>
);

export default ProductVariantSelector;
